export const language: any = {
  add_by_image: "通过图片添加",
  add_image_by_camera: "用相机拍摄",
  add_image_by_gallery: "从相册选择",
  loading: "正在准备美味的食谱，请稍等。",
  retry: "重试",
  cancel: "取消",
  yes: "是的",
  no: "不是",
  goToIngredient: "分析食材",
  goToRecipe: "分析食谱",
  recipe: {
    title: "AI 食谱",
    analysis_results: "分析结果",
    ingredients: {
      title: "材料 (1 人份)",
      view_more: "查看更多 {number} 种材料",
      view_less: "收起",
    },
    how_to_cook: "烹饪方法",
    go_to_detail: "查看 AI 食谱",
    description: "食谱简介",
    calories: "卡路里",
    time: "烹饪时间",
    ingredient: "主要食材",
    spice: "调味料",
    tip: "提示",
  },
  ingredient: {
    title: "图片分析",
    analysis_results: "从图片分析结果来看，以下是材料。",
    add_to_cart: "添加到购物车",
    add_to_my_ingredients: "添加到我的材料",
    description: "食谱介绍",
    time: "烹饪时间",
    ingredient: "主要食材",
    spice: "调料",
    tip: "小贴士",
  },
  msg: {
    not_ingredients: `这是一张很棒的照片，\n但这里是专门针对食材的！\n下次请拍一些美味的食材照片，\n烹饪的秘密在等待着你！\n要去AI厨师吗？`,
    // AC-01-MSG-01
    not_recipes: `嗯，这不是做菜的照片！\n我们只能分析食物照片。\n请上传完成的菜肴照片。\n要去分析食材吗？`,
    not_found: "未找到",
    unknow: `这似乎不是菜品或食材的照片。\n如果您上传菜品或食材的照片进行分析，\n我们会更好地为您提供帮助！`,
    upload_fail: `由于临时错误上传失败。\n请稍后再试。`,
    error: `哎呀！照片分析失败。\n请选择另一张照片，或\n尝试使用更清晰的照片？`,
    bothType: `这张图片同时包含食材和菜肴！\n请选择要分析的内容。`,
  },
}
